import React from 'react';

const icons = {
  add: {
    viewBox: '0 0 24 24',
    path:
      'M17 11a1 1 0 0 1 0 2h-4v4a1 1 0 0 1-2 0v-4H7a1 1 0 0 1 0-2h4V7a1 1 0 0 1 2 0v4h4z'
  },
  arrow: {
    viewBox: '0 0 24 24',
    path:
      'M15.3 9.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z'
  },
  exlamation: {
    viewBox: '0 0 24 24',
    path:
      'M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm0 9a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1zm0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'
  },
  checkmark: {
    viewBox: '0 0 24 24',
    path: 'M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z'
  },
  check: {
    viewBox: '0 0 24 24',
    path:
      'M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-2.3-8.7l1.3 1.29 3.3-3.3a1 1 0 0 1 1.4 1.42l-4 4a1 1 0 0 1-1.4 0l-2-2a1 1 0 0 1 1.4-1.42z'
  },
  help: {
    viewBox: '0 0 24 24',
    path:
      'M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM10.59 8.59a1 1 0 1 1-1.42-1.42 4 4 0 1 1 5.66 5.66l-2.12 2.12a1 1 0 1 1-1.42-1.42l2.12-2.12A2 2 0 0 0 10.6 8.6zM12 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'
  },
  close: {
    viewBox: '0 0 24 24',
    path:
      'M16.24 14.83a1 1 0 0 1-1.41 1.41L12 13.41l-2.83 2.83a1 1 0 0 1-1.41-1.41L10.59 12 7.76 9.17a1 1 0 0 1 1.41-1.41L12 10.59l2.83-2.83a1 1 0 0 1 1.41 1.41L13.41 12l2.83 2.83z'
  },
  home: {
    viewBox: '0 0 24 24',
    path:
      'M13 20v-5h-2v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7.59l-.3.3a1 1 0 1 1-1.4-1.42l9-9a1 1 0 0 1 1.4 0l9 9a1 1 0 0 1-1.4 1.42l-.3-.3V20a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2zm5 0v-9.59l-6-6-6 6V20h3v-5c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v5h3z'
  },
  soccer: {
    viewBox: '0 0 24 24',
    child: (
      <React.Fragment>
        <path d="M12.001,22.009c2.666,0,5.176-1.043,7.07-2.937c3.899-3.898,3.899-10.243,0-14.144c-1.895-1.895-4.405-2.938-7.07-2.938 c-2.666,0-5.177,1.044-7.072,2.938c-3.899,3.898-3.899,10.243,0,14.142C6.823,20.966,9.335,22.009,12.001,22.009z M12.181,4h-0.359 c0.061-0.001,0.119-0.009,0.18-0.009S12.12,3.999,12.181,4z M6.343,6.344c0.919-0.92,2.021-1.584,3.22-1.969L12,6l2.438-1.625 c1.198,0.385,2.301,1.049,3.22,1.968c0.663,0.663,1.177,1.418,1.558,2.221L18,11l1.858,2.478c-0.235,1.26-0.773,2.473-1.615,3.522 H16l-1.258,2.516c-0.868,0.318-1.791,0.493-2.741,0.493c-0.952,0-1.876-0.175-2.746-0.494L8,17.01H5.765 c-0.846-1.052-1.387-2.269-1.623-3.532L6,11L4.784,8.567C5.165,7.764,5.679,7.008,6.343,6.344z" />
        <path d="M14 15L15.5 11 12 8.5 8.5 11 10 15z" />
      </React.Fragment>
    )
  },
  football: {
    viewBox: '0 0 24 24',
    child: (
      <React.Fragment>
        <path d="M20.245,3.03c-0.069-0.018-1.742-0.433-4.052-0.433c-2.842,0-6.869,0.64-9.91,3.687c-5.339,5.349-3.34,13.61-3.252,13.96 c0.09,0.357,0.369,0.637,0.727,0.726c0.069,0.018,1.726,0.426,4.018,0.426c2.849,0,6.884-0.641,9.932-3.688 c5.335-5.335,3.351-13.6,3.264-13.949C20.881,3.4,20.603,3.12,20.245,3.03z M16.293,16.293c-2.564,2.563-6.047,3.103-8.518,3.103 c-1.255,0-2.303-0.139-2.924-0.245c-0.319-1.876-0.926-7.674,2.847-11.454c2.557-2.561,6.031-3.099,8.495-3.099 c1.27,0,2.33,0.142,2.955,0.25C19.464,6.725,20.063,12.523,16.293,16.293z" />
        <path d="M16.293 6.293L14.5 8.086 13.208 6.793 11.793 8.207 13.086 9.5 12 10.586 10.708 9.293 9.293 10.707 10.586 12 9.5 13.086 8.208 11.793 6.793 13.207 8.086 14.5 6.293 16.293 7.708 17.707 9.5 15.914 10.793 17.207 12.208 15.793 10.915 14.5 12 13.414 13.293 14.707 14.708 13.293 13.415 12 14.5 10.914 15.793 12.207 17.208 10.793 15.915 9.5 17.708 7.707z" />
      </React.Fragment>
    )
  },
  more: {
    viewBox: '0 0 24 24',
    path:
      'M4 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm8 2a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm8 2a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z'
  },
  notification: {
    viewBox: '0 0 24 24',
    path:
      'M15 19a3 3 0 0 1-6 0H4a1 1 0 0 1 0-2h1v-6a7 7 0 0 1 4.02-6.34 3 3 0 0 1 5.96 0A7 7 0 0 1 19 11v6h1a1 1 0 0 1 0 2h-5zm-4 0a1 1 0 0 0 2 0h-2zm0-12.9A5 5 0 0 0 7 11v6h10v-6a5 5 0 0 0-4-4.9V5a1 1 0 0 0-2 0v1.1z'
  },
  user: {
    viewBox: '0 0 24 24',
    path:
      'M12 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm9 11a1 1 0 0 1-2 0v-2a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v2a1 1 0 0 1-2 0v-2a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v2z'
  },
  trash: {
    viewBox: '0 0 24 24',
    path:
      'M8 6V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2h5a1 1 0 0 1 0 2h-1v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8H3a1 1 0 1 1 0-2h5zM6 8v12h12V8H6zm8-2V4h-4v2h4zm-4 4a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z'
  },
  edit: {
    viewBox: '0 0 24 24',
    path:
      'M6.3 12.3l10-10a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1 0 1.4l-10 10a1 1 0 0 1-.7.3H7a1 1 0 0 1-1-1v-4a1 1 0 0 1 .3-.7zM8 16h2.59l9-9L17 4.41l-9 9V16zm10-2a1 1 0 0 1 2 0v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h6a1 1 0 0 1 0 2H4v14h14v-6z'
  },
  tag: {
    viewBox: '0 0 24 24',
    path:
      'M2.59 13.41A1.98 1.98 0 0 1 2 12V7a5 5 0 0 1 5-5h4.99c.53 0 1.04.2 1.42.59l8 8a2 2 0 0 1 0 2.82l-8 8a2 2 0 0 1-2.82 0l-8-8zM20 12l-8-8H7a3 3 0 0 0-3 3v5l8 8 8-8zM7 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'
  }
};

export default icons;
